import React, { useEffect } from "react";
import { Button } from "src/business-types/grocery/components/Button";
import { useConfigurationState } from "./hooks/useConfigurationState";
import { PageTitle } from "../PageTitle";
import { useUser } from "src/business-types/grocery/components/UserContext";

const TermsConditionsTab = () => {
  const { addTC, setAddTC, tcEnglish, setTcEnglish, tcArabic, setTcArabic, saveTermsConditions } = useConfigurationState();
  const isRTL = (text: string) => {
    const rtlPattern = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
    return rtlPattern.test(text);
  };

  const detectLanguageName = (text: string) => {
    if (!text) return "Language";

    // Simple detection (can be improved with library)
    const rtlPattern = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
    const isArabic = rtlPattern.test(text);

    const langCode = isArabic ? "ar" : "en"; // fallback logic

    const display = new Intl.DisplayNames(["en"], { type: "language" });
    return display.of(langCode); // "Arabic" or "English"
  };

  const [initialState, setInitialState] = React.useState({
    addTC,
    tcEnglish,
    tcArabic,
  });
  const { user } = useUser();

  const handleSave = () => {
    saveTermsConditions({
      addTC,
      tcEnglish,
      tcArabic,
    });

    setInitialState({
      addTC,
      tcEnglish,
      tcArabic,
    });
  };

  useEffect(() => {
    setInitialState({
      addTC,
      tcEnglish,
      tcArabic,
    });
  }, []);

  const isChanged = addTC !== initialState.addTC || tcEnglish !== initialState.tcEnglish || tcArabic !== initialState.tcArabic;
  // if API loads later, replace with [addTC] or config flag
  useEffect(() => {
    if (user?.businessType !== "Grocery") {
      // document.title = "Tearms&Conditions› Configuration › iMetanic";
    }
  }, []);

  return (
     <div className='w-full mt-2 p-2 h-[82.9vh] overflow-hidden'>
    <div className='mx-auto px-4 sm:px-6 lg:px-8 border p-4 rounded-xl shadow bg-white h-[81.5vh] overflow-hidden'>
      {/* <PageTitle title=' - Configuration › Tearms&Conditions' /> */}
      <h1 className='text-xl font-bold mb-3'>Terms and Conditions in Print</h1>
      <div className='flex items-center mb-3 h-[5%]'>
        <label className='flex items-center gap-2 cursor-pointer'>
          <input type='checkbox' checked={addTC} onChange={() => setAddTC(!addTC)} className='w-4 h-4' />
          <span className='font-medium'>Add Terms and Conditions to printed bills</span>
        </label>
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6 h-[58%]'>
        <div>
          <h2 className="text-lg font-semibold mb-3">
            {detectLanguageName(tcArabic)} Version
          </h2>
          <textarea
            className='w-full h-full border rounded-lg p-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            placeholder='Enter terms and conditions in English...'
            disabled={!addTC}
            value={tcEnglish}
            onChange={(e) => setTcEnglish(e.target.value)}
          />
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-3">
            {isRTL(tcArabic) ? "Arabic Version" : "Other Language Version"}
          </h2>

          <textarea
            className="w-full h-full border rounded-lg p-3 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter terms and conditions..."
            disabled={!addTC}
            value={tcArabic}
            onChange={(e) => setTcArabic(e.target.value)}
            dir={isRTL(tcArabic) ? "rtl" : "ltr"}
            style={{
              textAlign: isRTL(tcArabic) ? "right" : "left",
            }}
          />
        </div>
      </div>
      {!addTC && <p className='text-xs text-gray-500 mt-2'>Enable the toggle above to add terms and conditions to printed bills</p>}
      <div className='flex justify-center mt-12'>
        <Button label='Save Terms & Conditions' onClick={handleSave} disabled={!isChanged} />
      </div>
    </div>
    </div>
  );
};

export default TermsConditionsTab;
